import * as _ from "underscore";
import { Cart } from "./app-cart";

interface Purchase {
    id: string;
    email: string;
    tax: string;
    subTotal: string;
}

export class Gtm {

    public static push(event: string, data: any, email?: string) {
        window.dataLayer = window.dataLayer || [];

        if (typeof (email) !== 'undefined') {
            data = {
                "event": event,
                "email": email,
                "ecommerce": data
            };
        } else {
            data = {
                "event": event,
                "ecommerce": data
                //"eventCallback": (containerId) => { console.log('Container ID: ' + containerId); }
            };
        };


        window.dataLayer.push(data);
        //console.log("gtm push data: " + JSON.stringify(data));
    }

    public static account(cart: Cart) {
        let self = this;

        if (!cart) { return; }

        const data = {
            'checkout': {
                'actionField': { 'step': 1, 'option': 'Account' },
                'products': _(cart.registrations()).map(x => ({
                    'id': x.allocation,
                    'name': x.camp.program.name,
                    'price': x.camp.price.replace(/[$,]/g, ''),
                    'brand': x.skillLevelsText,
                    'category': x.camp.location.name,
                    'variant': x.camp.dates,
                    'quantity': 1
                }))
            }
        }

        self.push("checkout", data);
    }

    public static checkout() {
        let self = this;

        const data = {
            'checkout': {
                'actionField': { 'step': 3, 'option': 'Checkout' }
            }
        }

        self.push("checkout", data);
    }

    public static options() {
        let self = this;

        const data = {
            'checkout': {
                'actionField': { 'step': 2, 'option': 'Options' }
            }
        }

        self.push("checkout", data);
    }

    public static purchase(cart: Cart, purchase: Purchase) {
        let self = this;

        const data = {
            'transaction_id': 'T' + purchase.id,
            'value': Number(purchase.subTotal.replace(/[$,]/g, '')),
            'tax': Number(purchase.tax.replace(/[$,]/g, '')),
            'currency': cart.region.currency == 'CAN' ? 'CAD' : cart.region.currency,
            'items': _(cart.registrations()).map(x => ({
                'item_id': x.allocation,
                'item_name': x.camp.program.name,
                'item_brand': x.skillLevelsText,
                'item_cateogry': x.camp.location.name,
                'item_variant': x.camp.dates,
                'price': Number(x.camp.price.replace(/[$,]/g, '')),
                'quantity': 1
            }))
        }

        self.push("purchase", data, purchase.email);
    }

    public static review(cart: Cart) {

        let self = this;

        var totalValue = _(cart.registrations())
            .map(x => Number(x.camp.price.replace(/[$,]/g, '')))
            .reduce((accumulatedPrice, itemPrice) => accumulatedPrice + itemPrice, 0);
      

        const data = {
            'currency': cart.region.currency == 'CAN' ? 'CAD' : cart.region.currency,
            'value': totalValue,                                                         // user subtotal here instead?
            'items': _(cart.registrations()).map(x => ({
                'item_id': x.allocation,
                'item_name': x.camp.program.name,
                'price': Number(x.camp.price.replace(/[$,]/g, '')),
                'item_brand': x.skillLevelsText,
                'item_cateogry': x.camp.location.name,
                'item_variant': x.camp.dates,
                'quantity': 1
            }))
        }

        self.push("add_to_cart", data);
    }
}
